import axios from 'axios';
import type { IFile } from '~/types/files';

const createFile = async (file: File): Promise<{ file: IFile }> => {
  const token = localStorage.getItem('token');
  const formdata = new FormData();
  formdata.append('file', file as any);

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/files`,
    formdata,
    {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response.data;
};

const deleteFile = async (id: string): Promise<{ message: string }> => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(
    `${process.env.REACT_APP_API_URL}/files/${id}`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return response.data;
};

export {
  createFile,
  deleteFile,
};
